/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'share': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M60.371 20.023c.54.074 1.047.29 1.469.625l32 25a2.995 2.995 0 0 1 1.148 2.36 2.99 2.99 0 0 1-1.148 2.359l-32 25a2.997 2.997 0 0 1-3.149.336 3.012 3.012 0 0 1-1.695-2.68v-9.969c-6.766.063-30.027 1.352-47.03 16.22a3 3 0 0 1-4.813-3.188c8.402-25.883 33.652-37.34 51.844-42.312v-10.75a3.026 3.026 0 0 1 1.007-2.266 3.015 3.015 0 0 1 2.368-.734zm2.625 9.125v6.875a2.996 2.996 0 0 1-2.25 2.906c-14.699 3.723-34.625 12.055-45.125 29 20.09-11.805 42.625-10.996 44.531-10.906a2.996 2.996 0 0 1 2.844 3v6.844L87.12 48.023z"/>'
  }
})
